import {
  DynamicOrchestrationConfig,
  JobStatus,
  OrchestrationGitLink,
  OrchestrationRunStatus,
  OrchestrationType,
  StaticOrchestrationConfig,
} from '@y42/json-schema';
import { UserUIModel } from '@y42/user/models';

type OrchestrationRunConfig =
  | {
      location: string;
    }
  | DynamicOrchestrationConfig
  | StaticOrchestrationConfig;

export class OrchestrationRunStoreModel {
  constructor(model: OrchestrationRunStoreModel) {
    this.run_id = model.run_id;
    this.type = model.type;
    this.status = model.status;
    this.payload = model.payload;
    this.run_config = model.run_config;
    this.created_at = model.created_at;
    this.updated_at = model.updated_at;
    this.finished_at = model.finished_at;
    this.triggered_by = model.triggered_by;
    this.details = model.details;
  }

  run_id: string;
  type: OrchestrationType;
  status: OrchestrationRunStatus;
  payload: OrchestrationRunConfig;
  run_config: StaticOrchestrationConfig | DynamicOrchestrationConfig;
  created_at: string;
  updated_at: string | null;
  finished_at: string | null;

  triggered_by: {
    type: 'user' | 'scheduler';
    mode: 'adhoc' | 'scheduler';
    user_id?: UserUIModel['id'];
  };

  details: {
    links: OrchestrationGitLink[];
    nodes: Record<string, OrchestrationRunJobDetailsStoreModel>;
  };
}

export interface OrchestrationRunJobDetailsStoreModel {
  job_id: string | null;
  job_status: JobStatus;
  path: string;
  name: string | null;
  entity_type: string | null;
  request_id: string | null;
  created_at: string;
  finished_at: string;
  details: { all_rows: number; new_rows: number };
}

export interface OrchestrationRunUIModel
  extends Omit<OrchestrationRunStoreModel, 'created_at' | 'updated_at' | 'finished_at'> {
  id: string;
  created_at: Date;
  updated_at: Date | null;
  finished_at: Date | null;
}
